import { render, staticRenderFns } from "./OurServicesPage.vue?vue&type=template&id=2cabfafe&scoped=true"
import script from "./OurServicesPage.vue?vue&type=script&lang=js"
export * from "./OurServicesPage.vue?vue&type=script&lang=js"
import style0 from "./OurServicesPage.vue?vue&type=style&index=0&id=2cabfafe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cabfafe",
  null
  
)

export default component.exports